export function waitFor(timeout: number, unit: 'msec' | 'sec' = 'msec'): Promise<void> {
    const scale = unit === 'msec' ? 1 : 1000;
    return new Promise(resolve => setTimeout(resolve, timeout * scale));
}

export function waitUntil(timestamp: number): Promise<void> {
    const delta = timestamp - Date.now();
    return (delta > 0) ? waitFor(delta) : Promise.reject();
}

function createExponentialBackoff(base = 2, factor = 100): (counter: number) => number {
    return (counter: number) => {
        return Math.pow(base, counter) * factor;
    };
}

export function createExponentialBackoffWait(base = 2, factor = 100): () => Promise<void> {
    const calcInterval = createExponentialBackoff(base, factor);
    let counter = 0;

    return async () => {
        const i = counter;
        counter++;
        const interval = calcInterval(i);
        console.log(`retry in ${interval} msec...`);
        return await waitFor(interval);
    };
}
